import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AclNgxModule } from '@amobee/acl-ngx';
import { MessageNotificationComponent } from './message-notification.component';
import { MessageNotificationContentComponent } from './message-notification-content/message-notification-content/message-notification-content.component';

@NgModule({
    imports: [CommonModule, AclNgxModule],
    declarations: [MessageNotificationComponent, MessageNotificationContentComponent],
    exports: [MessageNotificationComponent]
})
export class MessageNotificationModule { }
